<!--
  This component displays the card used to display collections and products
-->
<template>
  <div class="app-card d-flex flex-column align-start pa-3">
    <div class="app-card__image-wrapper">
      <div class="app-card__image">
        <!-- images -->
        <ListingImage
          :collection="item"
          :pictures="getPictures"
          :watch-for-pictures="source === 'search'" />
      </div>

      <!-- options menu -->
      <span
        v-if="$scopedSlots.actionSlot"
        class="app-card__options">

        <!-- Action Slot -->
        <slot
          name="actionSlot"
          :item="item" />

        <!-- Verified Mark -->
        <AppVerifiedMark
          :is-verified="item.isVerified"
          :child-verified-ws="item.childVerified"
          :verified-page-id="item.verifiedPageId"
          :verified-page-name="item.verifiedPageName" />
      </span>
    </div>
    <div class="app-card__label d-flex flex-column justify-center align-center align-self-stretch gap-1 text-center">
      <!-- For Community: Type of Card (Collection or Page) -->
      <template v-if="$route.name === 'community-collections' && cardLabel">
        <span class="w-100 fs-12 blue--text font-weight-bold lh-normal text-truncate">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on">
                {{ cardLabel }}
              </span>
            </template>
            {{ cardLabel }}
          </v-tooltip>
        </span>
      </template>

      <!-- Collections Name -->
      <span class="w-100 fs-18 font-fam-poppins font-weight-bold black--text text-truncate">
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on">
              {{ source === 'search' ? item.title : item.name }}
            </span>
          </template>
          {{ source === 'search' ? item.title : item.name }}
        </v-tooltip>
      </span>

      <!-- For Library - Collections Count -->
      <span
        v-if="isLibrary"
        class="fs-16 darkGrey--text">
        {{ item.collectionCount + ' Collections' }}
      </span>

      <!-- For Embed Collection -->
      <span
        v-if="showCollectionName"
        class="font-collection-name">
        Collection: {{ item.collectionName }}
      </span>
    </div>
  </div>
</template>

<script>
import ListingImage from '@/components/Listing/ListingImageItem/ListingImage';

import SetPictures from '@/mixins/SetPictures';

export default {
  name: 'AppCard',
  components: {
    ListingImage,
    AppVerifiedMark: () => import('@/components/App/AppVerifiedMark'),
  },
  mixins: [SetPictures],
  props: {
    isLibrary: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    showCollectionName: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: '',
    },
  },
  computed: {
    getPictures() {
      return this.source === 'search'
        ? this.getAttachments()
        : this.setPictures(this.item);
    },
    isCollectionGroup() {
      const { collectionGroup = '' } = this.item;
      const allowedCollectionGroup = ['followed', 'published', 'suggestion', 'collections'];
      return collectionGroup && allowedCollectionGroup.includes(collectionGroup);
    },
    cardLabel() {
      let label = '';

      if (this.isCollectionGroup) {
        label = this.item.verifiedPageName ? `Collection | ${this.item.verifiedPageName}` : 'Collection';
      } else if (this.item.collectionGroup === 'wsPages') {
        label = 'Page';
      }

      return label;
    },
  },
  methods: {
    getAttachments() {
      const { item } = this;
      const { attachment, logo: key } = item;
      let attachments = attachment.map(item => ({
        attachment: item,
      }));
      attachments = [
        ...attachments,
        ...(key ? [{
          key,
          isLogo: true,
        }] : []),
      ];
      return attachments;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-card {
  border-radius: 15px;
  border: 1px solid rgba(var(--v-blackRGB), 0.25);

  &__image-wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 305 / 201;
  }

  &__image {
    width: 100%;
    aspect-ratio: 305 / 201;
    border-radius: 15px;
    overflow: hidden;
  }

  &__options {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 3;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  &__label {
    padding: 16px 4px 4px;
    word-break: break-all;
  }
}
</style>